<template>
    <span>
      <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="9">
                    <h3>Exibir Programas do Governo</h3>
                    <br>                    
                 </b-col>
                 <b-col md="3">
                    <p><b>Nome:</b> {{ usuarioLogado.nome }}</p>
                    <p><b>Perfil:</b> {{ usuarioLogado.perfil }}</p>
                    <p><b>Estado:</b> {{ usuarioLogado.estado }}</p>
                    <p><b>Município:</b> {{ usuarioLogado.municipio }}</p>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <div v-if="programas !== undefined">                
                <b-card-group deck>  
                    <div v-for="programa in programas" :key="programa.id">                        
                        <b-card style="width: 60rem;" :img-src="programa.imagem_capa" img-alt="Card image" img-height="300" img-width="300" img-right class="mb-3">
                            <a @click="visualizarInformacao(programa.id)">
                                <b-card-text>
                                     <p><b>{{programa.titulo}}</b></p>
                                    <p>{{programa.texto}}</p>
                                </b-card-text>
                            </a>
                            <div style="position: absolute; left: 5%; bottom: 20px; width: 25%;">
                               <b-button block variant="primary" @click="abrirLink(programa.link)">                                 
                                    <span>Link</span>
                                </b-button>
                            </div>
                        </b-card>                      
                    </div>
                </b-card-group>               
            </div>
        </b-card-body>      
      </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created () {
    this.loadProgramas()
    this.$store.dispatch('buscarMunicipiosProgramas')
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
  },
  data () {
    return {
      programas: [],
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: '',
        nome: ''
      },
      possuiLike: false
    }
  },
  computed: {
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
     municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    }
  },
  watch: {
    'usuario.perfil': function () {
      this.usuarioLogado.perfil = this.usuario.perfil.nome
      this.usuarioLogado.nome = this.usuario.nome
    },
    'municipiosprogramas': function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    },
    'usuario.dados_pessoais': function () {
      this.municipiosprogramas.forEach(element => {
        if (element.municipio_id === this.usuario.dados_pessoais.municipio_atuacao_id) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    formatDate (data) {
        var extenso;
        
        data = new Date(data);

        var day = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"][data.getDay()];
        var date = data.getDate();
        var month = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"][data.getMonth()];
        var year = data.getFullYear();

        return `${date} de ${month} de ${year}`;
    },
    loadProgramas (){
        Vue.http.get('api/programas?ativo=true').then(response => {
            if (response.body.success) {
                this.programas = response.body.data.data
            }
        })
    },    
    navigate (route) {
      this.$router.push(route)
    },   
     abrirLink (link) {
      window.open(link, '_blank')
    },
  }
}
</script>

<style scoped>
    .action{
        programar: pointer;
    }
    .like {
        margin-left: 14rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/programaGoverno/ProgramaLista.vue